// extracted by mini-css-extract-plugin
export default {"gallery":"c-n_hx","gallery__header":"c-n_hy","gallery__thumbs":"c-n_hz"};